<template>
  <div class="site-width site-center text-center">
    <h1 class="text-h3">
      {{ $t('Page not found') }}
    </h1>
    <br>
    <a
      @click.prevent="$router.go(-1)"
      href="#"
    >{{ $t('Go to Homepage') }}</a>
  </div>
</template>

<script>
export default {
  name: 'page-404',
  metaInfo: {
    title: 'Not Found',
  },
};
</script>
<style lang="scss">
.page-404 {
  .site-content {
  }
}
</style>
